import { PractitionersSearchApi as PractitionersSearchApiI } from "./profile/api";
//import env from "react-dotenv";

export const PractitionersSearchApi = new PractitionersSearchApiI(null,/**env.PROFILE_SERVICE_URL*/ "http://localhost:3000");